const getRandomFloat = (min, max) => Math.random() * (max - min) + min;
const generateTimeStamp = (index = 0, showNow = false) => {
  const offset = 3 + index;
  const now = new Date();
  const [hours] = now.toISOString().split('T')[1].split(':');
  if (showNow) return now;
  return now.setHours(Number(hours) - offset, 0, 0, 0);
};

const createPEPSamples = (currentIndex, max, now) => Array.from({ length: max }, (_, index) => ({
  heartRate: getRandomFloat(61, 86),
  meanArterialPressure: '100.00',
  oxygenSaturation: getRandomFloat(96, 100),
  carbonDioxide: getRandomFloat(30, 36),
  timestamp: new Date(generateTimeStamp(currentIndex, now)).toISOString(),
  respiratoryRate: getRandomFloat(17, 20),
  systolicArterialPressure: '120.00',
  diastolicArterialPressure: '80.00',
  temperature: getRandomFloat(36.6, 39.4),
  vitalSigns: [`3473e4aa-7c69-4682-a${index.toString().padStart(3, '0')}z-c2cc9219bc2e`],
  isInvasive: false,
  isTemperatureEnabled: true,
  isCarbonDioxideEnabled: true,
  dispatchTimestamp: null,
}));

export const fetchDataPEPSimulation = (setState, pageSize) => {
  const timeStamp = new Date();
  const newItem = {
    date: new Date().toISOString(),
    isOutOfSchedule: true,
    vitalSigns: [`3473e4aa-7c69-4682-a${timeStamp.getTime()}z-c2cc9219bc2e`],
    period: {
      begin: '',
      end: '',
    },
    samples: createPEPSamples(0, 1, true),
  };

  setState((prev) => {
    const newArray = [newItem, ...prev.entries];
    if (newArray.length > pageSize) newArray.pop();
    return {
      ...prev,
      entries: newArray,
    };
  });
};

export const sendDataPEPSimulation = (setState, idSended) => {
  const dispatchTimestamp = new Date().toISOString();
  setState((prevState) => {
    const updatedEntries = prevState.entries.map((entry) => {
      if (!idSended.includes(entry.vitalSigns[0])) return entry;
      return {
        ...entry,
        samples: entry.samples.map((sample) => ({ ...sample, dispatchTimestamp })),
      };
    });
    return {
      ...prevState,
      entries: updatedEntries,
    };
  });
};

export const deleteDataPEPSimulation = (setState, idsToDelete) => {
  setState((prevState) => ({
    ...prevState,
    entries: prevState.entries.filter((entry) => !idsToDelete.includes(entry.vitalSigns[0])),
  }));
};

const generatePep = (max) => {
  if (!max || max < 0) return [];

  return Array.from({ length: max }, (_, index) => ({
    date: new Date().toISOString(),
    isOutOfSchedule: false,
    vitalSigns: [`3473e4aa-7c69-4682-a${index.toString().padStart(3, '0')}z-c2cc9219bc2e`],
    period: {
      begin: new Date(generateTimeStamp(index)).toISOString(),
      end: new Date(new Date(generateTimeStamp(index)).getTime() + ((60000) * 59)).toISOString(),
    },
    samples: createPEPSamples(index, max),
  }));
};

const icus = [
  {
    id: 1,
    icuName: 'Neonatal',
    hospital: 1,
  },
  {
    id: 2,
    icuName: 'Adulto',
    hospital: 1,
  },
  {
    id: 3,
    icuName: 'Pediatrica',
    hospital: 2,
  },
  {
    id: 4,
    icuName: 'Covid',
    hospital: 2,
  },
];

const hospitals = [
  {
    id: 1,
    hospitalName: 'Hospital Elizabeth Blackwell',
  },
  {
    id: 2,
    hospitalName: 'Hospital São Márcio',
  },
];

const pepConfigs = [
  {
    id: 1,
    icuId: null,
    icuName: null,
    hospitalId: null,
    hospitalName: null,
    isAutoSync: false,
    monitorFrequency: 60,
    airFrequency: 60,
    infusionFrequency: 60,
  },
  {
    id: 2,
    icuId: null,
    icuName: null,
    hospitalId: 1,
    hospitalName: 'Hospital Elizabeth Blackwell',
    isAutoSync: false,
    monitorFrequency: 15,
    airFrequency: 30,
    infusionFrequency: 60,
  },
  {
    id: 4,
    icuId: 4,
    icuName: 'Covid',
    hospitalId: 2,
    hospitalName: 'Hospital São Márcio',
    isAutoSync: true,
    monitorFrequency: 15,
    airFrequency: 30,
    infusionFrequency: 60,
  },
];

export const getPep = {
  GetPepConfig: () => ({
    getPepConfig: {
      monitor: 15,
      infusion: 30,
      air: 30,
      hospitals: [
        {
          id: 1,
          label: 'Hospital Elizabeth Blackwell',
          value: 'rede_carenet/hospital_elizabeth_blackwell',
          __typename: 'HospitalSelect',
        },
        {
          id: 2,
          label: 'Hospital São Márcio',
          value: 'rede_carenet/hospital_sao_marcio',
          __typename: 'HospitalSelect',
        },
      ],
      __typename: 'PepConfig',
    },
  }),
  // eslint-disable-next-line max-len
  UpdatePepConfig: (options) => {
    const { onCompleted } = options || {};
    const mutate = (callOptions) => {
      const { variables } = callOptions || {};
      const { pepConfig } = variables || {};

      const index = pepConfigs.findIndex((c) => c.id === pepConfig.id);

      if (index !== -1) {
        let { hospitalName, icuName } = pepConfigs[index];
        const {
          hospitalId: currentHospitalId,
          icuId: currentIcuId,
        } = pepConfigs[index];

        const targetHospitalId = pepConfig.hospital
          ? Number(pepConfig.hospital) : currentHospitalId;
        const targetIcuId = pepConfig.icu
          ? Number(pepConfig.icu) : currentIcuId;

        if (targetHospitalId) {
          const hospital = hospitals.find((h) => h.id === targetHospitalId);
          if (hospital) hospitalName = hospital.hospitalName;
        }

        if (targetIcuId) {
          const icu = icus.find((i) => i.id === targetIcuId);
          if (icu) icuName = icu.icuName;
        }

        pepConfigs[index] = {
          ...pepConfigs[index],
          ...pepConfig,
          hospitalId: targetHospitalId,
          icuId: targetIcuId,
          hospitalName,
          icuName,
        };
      } else {
        const newId = Math.max(...pepConfigs.map((c) => c.id), 0) + 1;

        let hospitalName;
        let icuName;

        if (pepConfig.hospital) {
          const hospital = hospitals.find((h) => h.id === Number(pepConfig.hospital));
          hospitalName = hospital?.hospitalName;
        }

        if (pepConfig.icu) {
          const icu = icus.find((i) => i.id === Number(pepConfig.icu));
          icuName = icu?.icuName;
        }

        const newConfig = {
          id: newId,
          icuId: pepConfig.icu ? Number(pepConfig.icu) : null,
          icuName: icuName || null,
          hospitalId: Number(pepConfig.hospital),
          hospitalName: hospitalName || null,
          isAutoSync: pepConfig.isAutoSync || false,
          monitorFrequency: pepConfig.monitorFrequency || 60,
          airFrequency: pepConfig.airFrequency || 60,
          infusionFrequency: pepConfig.infusionFrequency || 60,
        };
        pepConfigs.push(newConfig);
      }

      if (onCompleted) onCompleted();
      return { loading: false };
    };
    return [mutate, { loading: false }];
  },
  GetPep: () => {
    const itemsCount = 9;
    return {
      getPep: {
        entries: generatePep(itemsCount),
        entriesCount: itemsCount,
        pageNumber: 0,
        pageSize: 10,
        pagesCount: 2,
        pepStatus: '',
      },
    };
  },
  SendPep: ({ onCompleted }) => {
    const _ = () => [onCompleted(), { loading: false }];
    return [_, { loading: false }];
  },
  DeleteMonitorSamples: ({ onCompleted }) => {
    const _ = () => [onCompleted(), { loading: false }];
    return [_, { loading: false }];
  },
  UpdateVitalSignInPep: ({ onCompleted }) => {
    const _ = () => [onCompleted(), { loading: false }];
    return [_, { loading: false }];
  },
  ManualSample: (onCompleted) => [() => [onCompleted, { loading: false }], { loading: false }],

  DeletePepConfig: (options) => {
    const { onCompleted } = options || {};
    const mutate = (callOptions) => {
      const { variables } = callOptions || {};
      const { id } = variables || {};

      const index = pepConfigs.findIndex((c) => c.id === id);
      if (index !== -1) {
        pepConfigs.splice(index, 1);
      }

      if (onCompleted) onCompleted();
      return { loading: false };
    };
    return [mutate, { loading: false }];
  },

  InsertPepConfig: (options) => {
    const { onCompleted } = options || {};
    const mutate = (callOptions) => {
      const { variables } = callOptions || {};
      const { input } = variables || {};

      const newId = Math.max(...pepConfigs.map((c) => c.id), 0) + 1;

      const hospital = hospitals.find((h) => h.id === Number(input.hospital));
      const icu = icus.find((i) => i.id === Number(input.icu));

      const newConfig = {
        id: newId,
        icuId: input.icu ? Number(input.icu) : null,
        icuName: icu?.icuName || null,
        hospitalId: Number(input.hospital),
        hospitalName: hospital?.hospitalName || null,
        isAutoSync: input.isAutoSync || false,
        monitorFrequency: input.monitorFrequency || 60,
        airFrequency: input.airFrequency || 60,
        infusionFrequency: input.infusionFrequency || 60,
      };

      pepConfigs.push(newConfig);

      if (onCompleted) onCompleted();
      return { loading: false };
    };
    return [mutate, { loading: false }];
  },

  ListPepConfig: () => ({
    listHospitalAndIcus: {
      icus,
      hospitals,
    },
    listPepConfig: [...pepConfigs],
  }),
};
